// extracted by mini-css-extract-plugin
export default {"header":"Header_header__9suhT","logo":"Header_logo__LOfW3","date":"Header_date__mQ2rk"};